export const BRAND = {
  name: "WEN",
  full: "Wagering on Events",
  title: "WEN - Wagering on Events",
};

export const PRIVACY_BLURB =
  "Positions are keyed by a trading-key commitment, not your Moonlight address. Prices and pool reserves stay public. A deposit can still link a funding wallet to that commitment for that one transaction. On-chain KYC is off.";

/** One-liner for trade confirm / ticket - not the full About blurb. */
export const TRADE_PRIVACY_BLURB =
  "Positions are keyed by your trading commitment, not your Moonlight address. Pool prices stay public.";

/** Leaderboard header - commitments are masked, not wallet-linked. */
export const LEADERBOARD_PRIVACY_BLURB =
  "Rankings use masked trading-key commitments, not Moonlight addresses. Only the first eight hex digits are shown.";

/** Public display for a commitment hex or indexer `commitment_prefix`. */
export function maskCommitment(value, { prefixLen = 8 } = {}) {
  if (!value) return "-";
  const hex = String(value).trim().replace(/^0x/i, "").toLowerCase();
  if (!hex) return "-";
  if (hex.length <= prefixLen) return `${hex}…`;
  return `${hex.slice(0, prefixLen)}…`;
}

/** Always-visible court path on market detail Rules card. */
export const RULES_COURT_LINES = [
  "Assert YES: event owner, before close.",
  "Dispute / late challenge: anyone with a bond during the challenge window.",
  "Under review: dispute council resolves via multisig-tool (local CLI) - not in this portal.",
  "Quiet windows: unchallenged pending outcome finalizes when the window ends.",
];

export const ABOUT_HERO = {
  heading: "Wagering on Events",
  body: "Binary YES/NO prediction markets on Dusk testnet. Trade with a trading key. Prices and pool reserves stay public. Positions are keyed by commitment, not your Moonlight address. A deposit can still link a funding wallet to that commitment for that one transaction.",
};

export const HOW_IT_WORKS = [
  {
    step: "Connect a wallet",
    body: "Open the account menu and connect a Dusk wallet (Moonlight account).",
  },
  {
    step: "Get a participant id",
    body: "Request a participant id from the gateway, then prove wallet control with a tiny self-transfer memo - this is a soft onboarding check, not Citadel/compliance-gate KYC.",
  },
  {
    step: "Connect a trading key",
    body: "Sign a message with your wallet to derive a trading key, then link it to your participant id. The same wallet on this site origin re-derives the same key. The portal may cache it in this browser so a refresh does not force another signature - Disconnect or Clear key removes the local copy. This key signs your trades. Positions are keyed by its commitment, not your Moonlight address. A deposit can still link a funding wallet to that commitment for that one transaction.",
  },
  {
    step: "Deposit collateral",
    body: "Move DUSK from your wallet into contract collateral. Trades spend from this balance - only gas ever touches your wallet.",
  },
  {
    step: "Browse and trade",
    body: "Pick an event, buy YES or NO shares against the AMM pool. Prices move with every trade.",
  },
  {
    step: "Claim your payout",
    body: "Once an event resolves, claim your payout from Portfolio - or redeem collateral back if the event was cancelled.",
  },
  {
    step: "Build a win streak",
    body: "Trade on finalized markets to build a public win streak. Stats appear on Leaderboard once the indexer has processed your activity.",
  },
  {
    step: "Claim your achievement NFT",
    body: "After 3+ consecutive wins, claim a soulbound achievement NFT from Leaderboard or Achievements. The NFT mints to your Moonlight wallet and grants CREATE_MARKET right on-chain.",
  },
  {
    step: "Post participation bond",
    body: "In Settings, post the creator participation bond from your Moonlight balance. Operators and create-admin skip this step.",
  },
  {
    step: "Create events",
    body: "Once your NFT right is active, the Create tab appears. Post the participation bond in Account settings if prompted, then fill title, criteria, and seed liquidity to launch a new event.",
  },
];

export const ABOUT_SECTIONS = [
  {
    title: "What's public",
    body: "Event questions, YES/NO prices, pool reserves, the trade tape, and resolution status are public. Positions are keyed by a trading-key commitment, not your Moonlight address. The leaderboard shows masked commitment prefixes, not wallets. Deposit transactions can still link a funding wallet to a commitment for that one transaction. The API also stores your participant id and the self-transfer memo proof that binds your Moonlight wallet to that commitment. Full details are in the privacy policy.",
  },
  {
    title: "Resolution",
    body: "The event owner may assert YES before close_block. Otherwise the event defaults to NO. Anyone may bond-dispute an asserted YES; the owner may bond-challenge a default NO (late YES). Disputes enter Under review - the dispute council signs a resolve in local multisig-tool (web shows the case; CLI submits the quorum). Timeout keeps the pending outcome; owner portal Resolve is an escape hatch only.",
  },
];
